import { render, staticRenderFns } from "./PayMessageCard.vue?vue&type=template&id=5ab8f5f1&scoped=true&"
import script from "./PayMessageCard.vue?vue&type=script&lang=js&"
export * from "./PayMessageCard.vue?vue&type=script&lang=js&"
import style0 from "./PayMessageCard.vue?vue&type=style&index=0&id=5ab8f5f1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_uesoswnqfrvbmgjykhrr3r374i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab8f5f1",
  null
  
)

export default component.exports